import { Pipe, PipeTransform } from '@angular/core';
import { SlotType } from '../enums';

const SLOT_TYPE_CSS_CLASS_MAP: Record<SlotType, string> = {
    [SlotType.CheckboxInlineSlot]: 'checkbox-inline-slot',
    [SlotType.CheckboxTileSlot]: 'checkbox-tile-slot',
    [SlotType.RadioButtonInlineSlot]: 'radio-button-inline-slot',
    [SlotType.RadioButtonTileSlot]: 'radio-button-tile-slot',
    [SlotType.NumericInputSlot]: 'numeric-input-slot',
    [SlotType.NumericStepperSlot]: 'numeric-stepper-slot',
    [SlotType.NumericSliderSlot]: 'numeric-slider-slot',
    [SlotType.TextInputSlot]: 'text-input-slot',
    [SlotType.MultilineTextInputSlot]: 'multiline-text-input-slot',
    [SlotType.DateTimePickerSlot]: 'date-time-picker-slot',
    [SlotType.DatePickerSlot]: 'date-picker-slot',
    [SlotType.TimePickerSlot]: 'time-picker-slot',
    [SlotType.OptionalNumericInputTileSlot]: 'optional-numeric-input-tile-slot',
    [SlotType.OptionalTextInputTileSlot]: 'optional-text-input-tile-slot',
    [SlotType.DropdownSlot]: 'drop-down-slot',
    [SlotType.MultiselectDropdownSlot]: 'drop-down-multiselect-slot',
    [SlotType.AddressAutocompleteInputSlot]: 'address-autocomplete-input-slot',
    [SlotType.SeparatorSlot]: 'separator-slot'
};

@Pipe({
    name: 'slotTypeCssClass'
})
export class SlotTypeCssClassPipe implements PipeTransform {
    transform(slotType: SlotType | undefined): string {
        if (!slotType) {
            return '';
        }

        return SLOT_TYPE_CSS_CLASS_MAP[slotType];
    }
}
